module.exports = __webpack_public_path__ + "img/extension-pin-guide.965acb6f.png";